<template>
  <div>
  <!--<el-button size="small" @click="aa">查看进度</el-button>-->

  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="addOrUpdateTitle"
      :visible.sync="addOrUpdateVisible"
      :before-close="handleClose"
      width="60%">
      <!--<component :is="toDoForm" v-if="addOrUpdateVisible&&modifyType=='toDo'" :flowParam="flowParam"  @cancel="cancel"></component>-->
      <!--<component :is="printFrom" v-if="addOrUpdateVisible&&modifyType=='print'" :flowParam="flowParam"  @cancel="cancel"></component>-->
      <!--<delegation-person :row="0" v-if="addOrUpdateVisible&&modifyType=='delegation'" :modifyType="modifyType" @change="saveChildData" @cancel="cancel"></delegation-person>-->
      <view-pregress-status :flowId="taskId" v-if="addOrUpdateVisible&&modifyType=='view'" :canSetPerson="false"></view-pregress-status>
    </el-dialog>
  </div>
  </div>
</template>

<script>

  import ViewPregressStatus from "../../views/workFlow/viewProgressStatus/index";
  import DelegationPerson from "../../views/workFlow/todoList/delegationPerson/index";

    export default {
      name: "appoint-view-work-flow",
      components: {
        DelegationPerson,
        ViewPregressStatus
      },
      props:{
        taskId:{
          type:String,
        }
      },
      data() {
        return{
          sa:false,
          asa:'1234',
          loading:false,
          addOrUpdateVisible:false,
          addOrUpdateTitle:'',
          modifyType:'view',
          //动态组件中的值
          flowParam:{
            /*flowId:'',//流程id
            taskId:'',//代办任务id
            taskKey:'',// 代办任务key（在流程图中配置，用于部分需求来判断办理环节）
            flowKey:'',// 流程key （在流程定义和流程方案中确定）
            formType:'',//目前三个值，toDo 办理，print 打印 ，view 查看 当用一个表单实现三种功能时，可以用此参数判断
            */
          }

        }
      },

      methods:{
        // aa() {
        //   console.log(this.taskId)
        //   if(this.taskId == '' || this.taskId == null || this.taskId == undefined) {
        //     this.$emit('errorMsg','该数据未进入审批流！')
        //     return
        //   }
        //   // this.$emit('errorMsg','成功')
        //
        //   this.modifyData('view')
        //
        // },
        modifyData(type){
          this.modifyType = ''
          this.addOrUpdateTitle = ''
          if(type=='toDo'){
            this.addOrUpdateTitle='流程办理';
            this.modifyType='toDo'
            // if(this.ids.length!=1){
            //   this.$message.warning("请选择一条办理任务");
            //   return ;
            // }
            this.$fetchData(
              this.$api.myjob.toDo+"/"+this.ids[0],null,'POST'
            ).then(res => {
              console.log("办理表单",res)
              let formKey=res.formKey
              let businessKey=res.businessKey
              if(!formKey||formKey==''){
                this.$message.warning("此流程无办理表单配置，不能办理");
                return ;
              }
              if(formKey.startsWith("url:")){
                formKey=formKey.substring(4)
              }
              this.toDoForm=formKey;
              this.flowParam={
                flowId:this.checkedList[0].processInstanceId,
                busiId:businessKey.split("|")[1],
                taskId:this.checkedList[0].id,
                taskKey:this.checkedList[0].taskDefinitionKey,
                flowKey:this.checkedList[0].processDefinitionKey,
                formType:'toDo'
              }
              this.addOrUpdateVisible =true
            });
          }
          if(type=='delegation'){
            this.addOrUpdateTitle = '委派处理'
            // if(this.ids.length!=1){
            //   this.$message.warning("请选择一条信息进行委派");
            //   return ;
            // }
            this.addOrUpdateVisible =true
            this.modifyType='delegation'
          } if(type=='print'){
            this.addOrUpdateTitle = '打印流程'
            // if(this.ids.length!=1){
            //   this.$message.warning("请选择一条信息进行打印");
            //   return ;
            // }
            this.$fetchData(
              this.$api.myjob.print+"/"+this.ids[0],null,'POST'
            ).then(res => {
              console.log("打印表单", res)
              let businessKey=res.businessKey
              let printForm = res.formPrint
              if (!printForm || printForm == '') {
                this.$message.warning("此流程暂时不支持打印");
                return;
              }
              this.printFrom=printForm;
              this.flowParam={
                flowId:this.checkedList[0].processInstanceId,
                busiId:businessKey.split("|")[1],
                taskId:this.checkedList[0].id,
                taskKey:this.checkedList[0].taskDefinitionKey,
                flowKey:this.checkedList[0].processDefinitionKey,
                formType:'print'
              }
              this.addOrUpdateVisible =true
              this.modifyType='print'
            })
          }
          if(type=='view'){
            this.addOrUpdateTitle = '流程状态'
            // if(this.ids.length!=1){
            //   this.$message.warning("请选择一条信息查看进度");
            //   return ;
            // }
            this.flowParam={
              /*flowId:this.checkedList[0].processInstanceId,
              taskId:this.checkedList[0].id,
              taskKey:this.checkedList[0].taskDefinitionKey,
              flowKey:this.checkedList[0].processDefinitionKey,*/
              // formType:'view'
            }
            this.addOrUpdateVisible = true
            this.modifyType='view'
          }
          console.log('show dialog ',this.modifyType)

        },

        cancel(){
          this.addOrUpdateVisible=false;
        },
        handleClose(done){
          done()
          this.$emit('close',true)
        },
      },

      created() {
        console.log("niefuze"+this.taskId)
        // this.modifyData('view')
        this.addOrUpdateTitle = '流程状态'
        // if(this.ids.length!=1){
        //   this.$message.warning("请选择一条信息查看进度");
        //   return ;
        // }
        this.flowParam={
          /*flowId:this.checkedList[0].processInstanceId,
          taskId:this.checkedList[0].id,
          taskKey:this.checkedList[0].taskDefinitionKey,
          flowKey:this.checkedList[0].processDefinitionKey,*/
          // formType:'view'
        }
        this.addOrUpdateVisible = true
        this.modifyType='view'
      }

    }
</script>

<style scoped>

</style>
